import {
  Component,
  EventEmitter,
  Input,
  Output,
  TemplateRef,
  ViewChild
} from "@angular/core";

import { HeaderTab } from "@lantern/app/common/header-tabs";

export interface HeaderTabOptions {
  tabs: HeaderTab[];
  activeTab: HeaderTab;
}

export interface HeaderButtonOptions {
  text?: string;
  icon?: string;
  disabled?: boolean;
  link?: string;
}

@Component({
  selector: "ta-page-header",
  template: `
    <ng-template #template>
      <ta-flexbox
        class="w--100 ph--8 pv--6 mb--6 border--bottom items--center position--relative"
        justifyContent="space-between"
      >
        <span
          ><h1 class="thin-heading--1" [taTooltipStatic]="headerTextToolTip">
            {{ headerText | uppercase }}
          </h1></span
        >
        <div
          class="position--absolute"
          style="transform: translateX(-50%); left: 50%"
        >
          <ta-header-tabs
            *ngIf="tabOptions != null"
            [tabs]="tabOptions.tabs"
            [activeTab]="tabOptions.activeTab"
          >
          </ta-header-tabs>
        </div>

        <ta-link *ngIf="buttonOptions?.link; else headerButton" [taRouterLink]="buttonOptions?.link">
          <ng-container *ngTemplateOutlet="headerButton"></ng-container>
        </ta-link>
      </ta-flexbox>
    </ng-template>

    <ng-template #headerButton>
      <ta-button
        *ngIf="buttonOptions != null; else heightSpacer"
        [disabled]="buttonOptions.disabled"
        priority="primary"
        (interact)="headerButtonClick.emit()"
      >
          <span *ngIf="buttonOptions.icon" class="f--6 pr--1">
            <ta-icon
              *ngIf="buttonOptions.icon"
              [icon]="buttonOptions.icon"
            ></ta-icon>
          </span>
        <span *ngIf="buttonOptions.text">{{ buttonOptions.text }}</span>
      </ta-button>
    </ng-template>

    <!--  Always use the height the button would have  -->
    <ng-template #heightSpacer>
      <div style="height: 10rem"></div>
    </ng-template>
  `
})
export class PageHeaderComponent {
  @ViewChild("template", { static: true })
  template: TemplateRef<void>;

  @Input()
  headerText?: string;

  @Input()
  headerTextToolTip?: string;

  @Input()
  buttonOptions?: HeaderButtonOptions;

  @Input()
  tabOptions?: HeaderTabOptions;

  @Output()
  headerButtonClick: EventEmitter<void> = new EventEmitter<void>();
}
